import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, LockIcon, CheckIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 bg-sage-light/40" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-129">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-brown mb-6" data-id="element-130">
            Obtén el Sistema Completo de Calma hoy mismo
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl shadow-2xl shadow-brown/10 overflow-hidden max-w-2xl mx-auto border-2 border-sage" data-id="element-131">
          <div className="bg-sage text-white text-center py-3 font-medium tracking-wide text-sm uppercase" data-id="element-132">
            Precio Especial de Lanzamiento
          </div>

          <div className="p-8 sm:p-12" data-id="element-133">
            <div className="text-center mb-8" data-id="element-134">
              <h3 className="text-2xl font-heading font-bold text-brown mb-2" data-id="element-135">
                Controla la Ansiedad — Sistema Completo
              </h3>
              <p className="text-brown-light" data-id="element-136">
                Acceso inmediato a todo el material digital
              </p>
            </div>

            <div className="flex justify-center items-baseline gap-3 mb-8" data-id="element-137">
              <span className="text-2xl text-brown-light line-through decoration-terracotta/50" data-id="element-138">
                $47
              </span>
              <span className="text-6xl font-heading font-bold text-brown" data-id="element-139">
                $27
              </span>
              <span className="text-sm font-medium text-terracotta bg-terracotta/10 px-3 py-1 rounded-full" data-id="element-140">
                Ahorra 43%
              </span>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-141">
              {['Guía PDF "Camino a la Calma" — Manual completo', 'Audiolibro Completo (5 Tracks)', 'Tarjeta S.O.S de Emergencia (7 Páginas)', 'Acceso de por vida a futuras actualizaciones'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-142">
                  <CheckIcon className="w-5 h-5 text-sage mt-0.5 flex-shrink-0" data-id="element-143" />
                  <span className="text-brown-light font-medium" data-id="element-144">{item}</span>
                </li>)}
            </ul>

            <CTAButton href="https://elevaemily.com/products/controla-la-ansiedad-1?variant=53010420498795" size="lg" className="w-full mb-6 text-xl py-5" data-id="element-145">
              ¡Quiero Mi Protocolo de Calma Ahora!
            </CTAButton>

            <p className="text-center text-sm text-brown-light/70 mb-6" data-id="element-146">
              Compra 100% segura. Descarga inmediata disponible para Android,
              iPhone y Computadora.
            </p>

            <div className="flex flex-wrap justify-center gap-4 sm:gap-8 text-sm text-brown-light/80" data-id="element-147">
              <div className="flex items-center gap-1.5" data-id="element-148">
                <LockIcon className="w-4 h-4" data-id="element-149" />
                <span data-id="element-150">Pago seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-151">
                <DownloadIcon className="w-4 h-4" data-id="element-152" />
                <span data-id="element-153">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-154">
                <SmartphoneIcon className="w-4 h-4" data-id="element-155" />
                <span data-id="element-156">Todos los dispositivos</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}